module.exports = __webpack_public_path__ + "images/87f85a35e08638678d88e28b4661acf1e98135c7db5410e6458ede230a684758.svg";